/**
 * Global state for the collaborative evidence annotator overlay.
 *
 * When `openEvidenceId` is non-null, both operator and field render
 * `<EvidenceAnnotator />` full-screen on top of the LiveKit grid and
 * collaboratively mark up the captured still. The `evidence/view.open`
 * envelope sets it; `evidence/view.close` clears it.
 *
 * Operator-only initiation is a UI policy (the close + open buttons are
 * gated by which side you're on). The store itself is symmetric so a
 * future change to allow field-initiation needs no plumbing changes.
 */
import { create } from "zustand";

type Store = {
  openEvidenceId: string | null;
  open: (evidenceId: string) => void;
  close: () => void;
};

export const useCollabAnnotatorStore = create<Store>((set) => ({
  openEvidenceId: null,
  open: (evidenceId) => set({ openEvidenceId: evidenceId }),
  close: () => set({ openEvidenceId: null }),
}));